// Components
import Grid, { GridProps } from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

type LoaderType = {
  text?: string;
  size?: string;
  color?: string;
  containerProps?: GridProps;
};

const Loader = ({
  text = "",
  color = "#E2772E",
  size = "50px",
  containerProps = { height: "100vh" },
}: LoaderType) => (
  <Grid
    container
    direction="column"
    alignItems="center"
    justifyContent="center"
    gap={1}
    data-testid="loader"
    {...containerProps}
  >
    <CircularProgress sx={{ color }} size={size} disableShrink />
    {text ? <Typography sx={{ color }}>{text}</Typography> : null}
  </Grid>
);

export default Loader;
